import * as React from "react";
import Box from "@mui/material/Box";
import ViewManageReferralReq from "./ViewManageReferralReq";



const ManageReferralReqHome = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <ViewManageReferralReq />
    </Box>
  );
};

export default ManageReferralReqHome;
